import styled, { keyframes } from "styled-components";

// Keyframes for blinking text effect
const blinkAnimation = keyframes`
  50% {
    opacity: 0;
  }
`;

// Keyframes for loading animation (progress bar moving)
const loadingAnimation = keyframes`
  0% {
    width: 0;
  }
  50% {
    width: 100%;
  }
  100% {
    width: 0;
  }
`;

// The container for the loading screen (Centered)
export const SpinnerContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(255, 255, 255, 0.9); // Slight transparent background
  z-index: 1000; // Make sure it's on top of other elements
`;

// Container for the logo and loading circle
export const LogoAndBarContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  margin-bottom: 20px;
`;

// Styled component for the logo
export const Logo = styled.div`
  width: 80px;
  height: 80px;
  background-color: #005abb; // Logo background color
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-bottom: 20px; // Space between logo and loading bar

  &::before {
    content: '📱'; // Emoji as logo, replace with an image or icon if needed
    font-size: 40px;
    color: white;
  }

  @media (max-width: 768px) {
    width: 60px;
    height: 60px;
  }
`;

// Circular loading bar
export const LoadingCircle = styled.div`
  width: 60px;
  height: 60px;
  border: 4px solid #f0f0f0;
  border-top-color: #005abb;
  border-radius: 50%;
  animation: ${loadingAnimation} 1.5s linear infinite;
`;

// The text with blinking effect
export const BlinkingText = styled.div`
  font-size: 18px;
  font-weight: bold;
  color: #005abb;
  animation: ${blinkAnimation} 1.5s infinite;
  text-align: center;

  @media (max-width: 768px) {
    font-size: 14px; // Smaller font size for mobile screens
  }
`;

